import gql from 'graphql-tag'

export const UPDATE_CART_ITEM_COMMENT = gql`
  mutation UpdateCartItemComment($cartItemId: Int!, $value: String) {
    updateCartItemComment(cartItemId: $cartItemId, value: $value) {
      cartItemId
    }
  }
`
